import { createRoutine } from 'redux-saga-routines'

export const SET = 'VOLUNTEERS/SET'
export const CONTENT = createRoutine('VOLUNTEERS/CONTENT')
export const POST = createRoutine('VOLUNTEERS/POST')
